<template>
  <div
    :class="rampHolderClass"
  >
    <div class="ramp">
      <div
        :class="rampValClass(-2)"
      >
        {{ magnitude }}
      </div>
      <div
        v-for="(rmp,rampIndex) in rampDomain"
        :id="`ramp-${rampIndex}`"
        :key="`ramp-${rampIndex}`"
        :data-ramp-id="rampIndex"
        :class="rampClass(rampIndex)"
      >
        <div
          :class="rampDomainClass()"
          :style="rampDomainStyle(rampIndex)"
        />
        <div
          :class="rampValClass(rampIndex)"
        >
          {{ rampDomainVal(rampIndex) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ramp: {
      type: Object,
      default: () => {},
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    labeled: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'gray',
    },
    idx: {
      type: Number,
      default: undefined,
    },
    magnitude: {
      type: String,
      default: '',
    },
    perc: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rampDomain () {
      let res
      if (!this.perc) {
        res = this.ramp.domain
      } else {
        res = this.ramp.domainPerc
      }
      return res
    },
    rampHolderClass () {
      const { color } = this
      return [`border-${color}-500 text-${color} border mt-1 py-1 px-1 uppercase text-sm`]
    },
  },
  methods: {
    rampDomainVal (index) {
      let res
      if (!this.perc) {
        res = `${this.ramp.symbol[index]} ${this.ramp.domain[index]} ${this.ramp.unit[index]}`
      } else {
        res = `${this.ramp.symbol[index]} ${this.ramp.domainPerc[index]} ${this.ramp.unitPerc[index]}`
      }
      return res
    },
    rampRangeVal (index) {
      let res
      if (!this.perc) {
        res = this.ramp.range[index]
      } else {
        res = this.ramp.rangePerc[index]
      }
      return res
    },
    rampClass () {
      const { color } = this
      return [`rampItem border-${color}`]
    },
    rampDomainStyle (index) {
      let res
      if (this.bg !== '' && this.enabled) {
        if (!this.perc) {
          res = `background-color: ${this.bg};opacity: ${this.ramp.range[index]}`
        } else {
          res = `background-color: ${this.bg};opacity: ${this.ramp.rangePerc[index]}`
        }
      } else {
        if (!this.perc) {
          res = `background-color: ${this.ramp.color[index]};opacity: ${this.ramp.range[index]}`
        } else {
          res = `background-color: ${this.ramp.color[index]};opacity: ${this.ramp.rangePerc[index]}`
        }
      }
      return res
    },
    rampDomainClass () {
      const { color } = this
      return [`rampDomain border-${color}-500 text-${color} border py-1 px-1 uppercase text-sm`]
    },
    rampValClass (index) {
      let { color } = this
      let res
      if (index === this.idx && this.labeled) {
        color = 'white'
        res = [`rampVal actived text-${color} py-1 px-1 uppercase text-sm`]
      } else {
        res = [`rampVal text-${color} py-1 px-1 uppercase text-sm`]
      }
      return res
    },
  },
}
</script>

<style lang="scss">

@import '@/mixin.scss';

.ramp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (min-width: 640px) {
    flex-direction: row;
  }
}

.rampItem {
  //width: 1rem;
  display: flex;
}

.rampDomain {
  width: 2rem;
}

.rampVal {
  &.actived {
    background-color: var(--bg-color-alt);
  }
}

</style>
